<template>
  <navbar
    position="fixed"
    type="primary"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template slot-scope="{ toggle, isToggled }">
      <router-link v-popover:popover1 class="navbar-brand" to="/">
        <img class="loyalty-logo" src="../assets/assets_loyalty/assets-19.png">
      </router-link>
    </template>
    <template slot="navbar-menu">
      <li class="nav-item only_mobile">
        <router-link  to="/">
          <a class="nav-link">
            <p class="navbar-titles">Inicio</p>
          </a>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link  :to="{ path: '/', hash: '#comercio' }">
          <a class="nav-link">
            <p class="navbar-titles">Comercios afiliados</p>
          </a>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link  :to="{ path: '/', hash: '#contact' }">
          <a class="nav-link" target="_blank">
            <p class="navbar-titles">Contacto</p>
          </a>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link  to="/quienes_somos">
          <a class="nav-link" href="/" target="_blank">
            <p class="navbar-titles">Sobre nosotros</p>
          </a>
        </router-link>
        <!-- <a class="nav-link" to="/quienes_somos" to="/quienes_somos" target="_blank">
          <p class="navbar-titles">Sobre nosotros</p>
        </a> -->
      </li>
      <li class="nav-item">
        <router-link to="/login">
        <n-button  type="info" class="nav-link" round>
            <p>Iniciar sesión</p>
        </n-button>
        </router-link>
      </li>
    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink, Button, Modal} from '@/components';
import { Popover } from 'element-ui';
import Registro from '../pages/components/Registro';
export default {
  name: 'main-navbar',
  data() {
    return {
      modals: {
        classic: false,
      }
    }
  },
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover,
    [Button.name]: Button
  },
  methods: {
      // scrollMeTo(refName) {
      //   var element = this.$refs[refName];
      //   var top = element.offsetTop;

      //   window.scrollTo(0, top);
      // },
    test(to, from, savedPosition) {
        return { x: 0, y: 0 }
      console.log('TEST')
    }
  }
};
</script>

<style scoped>
.navbar-titles{
  color: black;
  font-weight: bold;
}
.loyalty-logo{
  width: 200px;
}
.only_mobile{
  display: none;
}
@media screen and (min-width: 321px) and (max-width: 768px) { 
  .navbar-titles{
    color: rgba(65, 65, 65);
    font-weight: bold;
  }
  .loyalty-logo{
    width: 180px;
  }
  .only_mobile{
    display: block;
  }
}
</style>
